document.addEventListener("DOMContentLoaded", () => {
  const popupWrapper = document.getElementById("custom-popup-wrapper");
  const openPopupButton = document.getElementById("open-custom-popup");
  const closePopupButton = document.getElementById("custom-popup-close");
  const cancelButton = document.getElementById("custom-popup-cancel");
  const findButton = document.getElementById("custom-popup-find");
  const applyButton = document.getElementById("custom-popup-apply");
  const inputField = document.getElementById("custom-popup-input");
  const statusMessage = document.getElementById("custom-popup-status");
  const iframe = document.getElementById("3d");
  let fetchedConfig = null;
  let hexCode = null;
  const fileReference = {};

  // Change this as this is a global variable for isProduction (API urls controlled by this!)
  window.isProduction = true;

  // Controls if we use production or development API URL
  const isProduction = window.isProduction;

  function getSaveConfigFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("saveConfig");
  }

  const isValidHexCode = (code) => code.length === 8;

  const saveConfigHex = getSaveConfigFromUrl();

  openPopupButton.addEventListener("click", () => {
    inputField.value = saveConfigHex || "";
    popupWrapper.classList.remove("hidden");
  });

  [closePopupButton, cancelButton].forEach((button) =>
    button.addEventListener("click", () => {
      popupWrapper.classList.add("hidden");
      inputField.value = "";
      statusMessage.textContent = "";
      statusMessage.classList.add("hidden");
      applyButton.disabled = true;
      findButton.disabled = true;
    })
  );

  inputField.addEventListener("input", () => {
    const code = inputField.value.trim();
    findButton.disabled = !isValidHexCode(code);
    applyButton.disabled = true;
  });

  findButton.addEventListener("click", async () => {
    const code = inputField.value.trim();
    if (!isValidHexCode(code)) {
      statusMessage.textContent = "Code must be exactly 8 characters.";
      statusMessage.classList.add("error");
      statusMessage.classList.remove("hidden", "success");
      return;
    }

    await validateAndFetchConfig(code);
  });

  applyButton.addEventListener("click", () => {
    if (fetchedConfig) {
      updateSelectedVariants(fetchedConfig);
      popupWrapper.classList.add("hidden");

      fetchedConfig.forEach(({ sku, properties }) => {
        let details = { type: "SKU_details", sku };
        if (properties) {
          details.properties = properties;
        }
        sendMessageToIframe(details);
      });
    }
  });

  async function updateSelectedVariants(config) {
    const variantButtons = document.querySelectorAll(
      ".watch-part__variant-button"
    );

    config.forEach(({ sku, properties }) => {
      const button = Array.from(variantButtons).find(
        (btn) => btn.dataset.variantSku === sku
      );

      if (button) {
        const parentCategory = button.closest(".product-category");

        parentCategory
          .querySelectorAll(".watch-part__variant-button")
          .forEach((btn) => {
            btn.classList.remove("selected");
          });
        button.classList.add("selected");

        parentCategory
          .querySelectorAll(".variant-description")
          .forEach((desc) => {
            desc.classList.add("hidden");
          });
        const description = parentCategory.querySelector(
          `.variant-description#description-${button.dataset.variantId}`
        );
        if (description) description.classList.remove("hidden");

        parentCategory.querySelectorAll(".disclaimer").forEach((disc) => {
          disc.classList.add("hidden");
        });
        const disclaimer = parentCategory.querySelector(
          `.disclaimer#disclaimerID-${button.dataset.variantId}`
        );
        if (disclaimer) disclaimer.classList.remove("hidden");

        const engravingInput = parentCategory.querySelector(
          ".engraving-text-input"
        );
        if (engravingInput && properties?.engravingText) {
          engravingInput.value = properties.engravingText;
          engravingInput.classList.remove("hidden");
        }

        const fontSelection = parentCategory.querySelector("#fontSelection");
        if (fontSelection && properties?.font) {
          fontSelection.value = properties.font;
        }

        handleSkeletonKenissiVisibility(button);
      }
    });
  }

  function sendMessageToIframe(skuDetails) {
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(skuDetails, "*");
      console.log("Sending message to iframe with:", skuDetails);
    }
  }

  function handleSkeletonKenissiVisibility(element) {
    if (element.classList.contains("skeletonSelected")) {
      document
        .querySelectorAll(".watch-part__variant-button.kenissi")
        .forEach((button) => {
          button.classList.add("hidden");
        });
      document
        .querySelectorAll(".watch-part__variant-button.skeleton")
        .forEach((button) => {
          button.classList.remove("hidden");
        });
    } else if (element.classList.contains("kenissiSelected")) {
      document
        .querySelectorAll(".watch-part__variant-button.skeleton")
        .forEach((button) => {
          button.classList.add("hidden");
        });
      document
        .querySelectorAll(".watch-part__variant-button.kenissi")
        .forEach((button) => {
          button.classList.remove("hidden");
        });
    }
  }

  if (saveConfigHex) {
    console.log("Found saveConfig parameter in URL:", saveConfigHex);

    // Validate and fetch the configuration
    validateAndFetchConfig(saveConfigHex);
  }

  // Function to validate and fetch the configuration
  async function validateAndFetchConfig(code) {
    if (code.length !== 8) {
      console.error("Invalid hex code:", code);
      return;
    }

    try {
      const apiUrl = isProduction
        ? `https://norqain-watch-configurator.gadget.app/config/savedConfig?hexCode=${code}`
        : `https://norqain-watch-configurator--development.gadget.app/config/savedConfig?hexCode=${code}`;

      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error("Configuration not found or invalid hex code.");
      }

      const result = await response.json();
      fetchedConfig = result?.savedConfig?.savedConfiguration || null;
      hexCode = result?.savedConfig?.hexCode || null;

      window.hexCode = hexCode;

      if (fetchedConfig) {
        console.log("Fetched configuration for hex code:", fetchedConfig);
        statusMessage.textContent = `${hexCode} found successfully!`;
        statusMessage.classList.add("success");
        statusMessage.classList.remove("hidden", "error");
        applyButton.disabled = false;
        console.log("Fetched Config:", fetchedConfig);
        console.log("Hex code saved:", hexCode);
      } else {
        console.warn("No configuration found for hex code:", hexCode);
      }
    } catch (error) {
      fetchedConfig = null;
      statusMessage.textContent = "Code not found. Please try again.";
      statusMessage.classList.add("error");
      statusMessage.classList.remove("hidden", "success");
      applyButton.disabled = true;
      console.error("Error fetching configuration:", error);
    }
  }

  // Add event listener to listen for PlayCanvasStarted message
  window.addEventListener("message", (event) => {
    // Check if the message type is 'PlayCanvasStarted'
    if (event.data && event.data.type === "PlayCanvasStarted") {
      console.log("Received PlayCanvasStarted message:", event.data);

      // Proceed to push configuration to the iframe
      if (fetchedConfig && Array.isArray(fetchedConfig)) {
        updateSelectedVariants(fetchedConfig);
        popupWrapper.classList.add("hidden");

        fetchedConfig.forEach(({ sku, properties }) => {
          let details = { type: "SKU_details", sku };
          if (properties) {
            details.properties = properties;
          }
          sendMessageToIframe(details);
        });
      } else {
        console.warn("No fetched configuration available to push.");
      }
    }
  });
});
